module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Lenox-ec05065f14c72081fbd586e037b2788a.png";